module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-main"
  }, [_c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://ms0.meituan.net/touch/css/i/404.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n                            你所访问的页面不存在\n                            "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63098a55","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 996
// module chunks = 0